import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const twoFactorSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    get2FASetup: build.mutation<any, void>({
      query: () => ({
        url: `${urlConfig.authBaseUrl}/auth/2fa/setup`,
        method: 'GET',
      }),
    }),

    confirmSetup: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/2fa/confirm`,
        method: 'POST',
        body,
      }),
    }),

    disable2FA: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/2fa/disable`,
        method: 'POST',
        body,
      }),
    }),

    verify2FA: build.mutation({
      query: body => ({
        url: `${urlConfig.authBaseUrl}/auth/2fa/verify`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useGet2FASetupMutation,
  useConfirmSetupMutation,
  useDisable2FAMutation,
  useVerify2FAMutation,
} = twoFactorSlice
